import { useRouter } from "next/router";
import { useState } from "react";
import { Button } from "src/components/rough/Button";
import { Dialog } from "src/components/rough/Dialog";
import { Label } from "src/components/rough/Label";
import { TextInput } from "src/components/rough/TextInput";
import { useCreateIntervention } from "src/data/mutations/useCreateIntervention";
import { VisibilitySelect } from "../Shared/VisibilitySelect";
import { Textarea } from "../../Textarea";

type CreateInterventionDialogProps = {
  open: boolean;
  onOpenChange: (value: boolean) => void;
};

export const CreateInterventionDialog = ({ open, onOpenChange }: CreateInterventionDialogProps) => {
  const router = useRouter();

  const [createIntervention] = useCreateIntervention();
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [visibility, setVisibility] = useState("private");

  const addIntervention = () => {
    if (name === "") {
      alert("Please pick a name for your activity.");
      return;
    }

    createIntervention({
      variables: {
        description,
        name,
        visibility,
      },
    })
      .then((res) => {
        const id = res.data?.createIntervention?.id;
        if (!id) return;

        router.push(`/interventions/builder/${id}`);
      })
      .catch((e) => {
        if (e.message.includes("enable_create_global_interventions")) {
          alert("This clinic cannot create global activities");
        }
      })
      .finally(() => {
        setName("");
        setDescription("");
        setVisibility("private");
      });
  };

  return (
    <Dialog.Dialog open={open} onOpenChange={onOpenChange}>
      <Dialog.Content>
        <Dialog.Title>Create an activity</Dialog.Title>
        <Dialog.Description>Create a brand new, state of the art, activity</Dialog.Description>
        <div className="mt-4">
          <Label htmlFor="InterventionNameInput">Name</Label>
          <TextInput
            className="mt-2"
            id="InterventionNameInput"
            onValueChange={(e) => setName(e.target.value)}
            value={name}
            placeholder={"The great activity"}
          />

          <div className="mt-4 flex flex-col gap-2">
            <Label htmlFor="InterventionDescInput">Description</Label>
            <Textarea
              id="InterventionDescInput"
              onValueChange={(e) => setDescription(e.target.value)}
              value={description}
              placeholder={"Help people understand this activity at a glance"}
            />
          </div>

          <div className="mt-4">
            <Label htmlFor="VisibilityInput">Visibility</Label>
            <div className="mt-2">
              <VisibilitySelect onChange={(val) => setVisibility(val)} value={visibility} />
            </div>
          </div>
        </div>

        <Dialog.Footer>
          <Dialog.Close>
            <Button variant="primary" text={"Create"} onClick={addIntervention} />
          </Dialog.Close>
          <Dialog.Close>
            <Button variant="ghost" text="Cancel" />
          </Dialog.Close>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Dialog>
  );
};
